import { render, staticRenderFns } from "./ViOnlineTc.vue?vue&type=template&id=1abf9cfe"
import script from "./ViOnlineTc.vue?vue&type=script&lang=js"
export * from "./ViOnlineTc.vue?vue&type=script&lang=js"
import style0 from "./ViOnlineTc.vue?vue&type=style&index=0&id=1abf9cfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports